import React from 'react';
import { Container, Image } from 'semantic-ui-react';
import conga from 'assets/png/conga-login.png';
import { ReactComponent as CecoLogo } from 'assets/svg/ic_cecotec_blue.svg';
import { ArrowRight } from 'assets/icons';
import { version } from '../../../package.json';
import './AuthLayout.scss';

function AuthLayout({ children }) {
  return (
    <>
      <div className="auth-layout">
        <Container className="auth-layout-box">
          <div className="auth-layout-sidepane">
            <Image src={conga} className="auth-layout-decoration" />
            <CecoLogo className="logo-cecotec" />
            <ArrowRight className="arrow-right" />
            <h2>{'Drop\nshipments'}</h2>
            <div>v{version}</div>
          </div>
          <div className="auth-layout-container">
            {React.cloneElement(React.Children.only(children))}
          </div>
        </Container>
      </div>
    </>
  );
}

export const withAuthLayout = (Component) => (props) =>
  (
    <AuthLayout {...props}>
      <Component {...props} />
    </AuthLayout>
  );
